import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDmS_2HSsPvgsq5NgrXdSZWyEKWywGb3fU",
  authDomain: "somebodygives-85799.firebaseapp.com",
  projectId: "somebodygives-85799",
  storageBucket: "somebodygives-85799.firebasestorage.app",
  messagingSenderId: "628374299650",
  appId: "1:628374299650:web:b90e492b59c464b6d2b31b",
  measurementId: "G-6ZH1NL5G7G"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;